import { memo, useEffect, useRef, useState } from "react";
import { FaChevronDown, FaPhone, FaUserAlt } from "react-icons/fa";
import { telHref } from "../../../utils/firmContacts";

const ContactLine = ({ contact, className = "" }) => (
  <span className={`inline-flex min-w-0 items-center gap-1.5 ${className}`}>
    <FaUserAlt className="h-2.5 w-2.5 shrink-0 text-teal-500" />
    <span className="truncate font-SemiBold text-gray-700">{contact.name}</span>
    {contact.tel && (
      <a
        href={telHref(contact.tel)}
        onClick={(e) => e.stopPropagation()}
        className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-emerald-700 hover:underline"
      >
        <FaPhone className="h-2.5 w-2.5" />
        {contact.tel}
      </a>
    )}
  </span>
);

/**
 * Molekül: sipariş vermeyen firmada muhataplar (#367). Bayser No altında ilk
 * muhatap görünür; birden fazlaysa sayaçlı düğme açılır listeyi açar. Liste
 * satırın ÜSTÜNDE yüzen katmandır — alttaki satırları itmez. Dışarı tıklama
 * ve Escape kapatır.
 */
function FirmContactsMenu({ contacts, className = "" }) {
  const list = Array.isArray(contacts) ? contacts.filter((c) => c?.name) : [];
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (list.length === 0) return null;
  const [first, ...rest] = list;

  return (
    <div ref={ref} data-keep-bill className={`relative flex min-w-0 items-center gap-1.5 text-[11px] ${className}`}>
      <ContactLine contact={first} className="max-w-full" />
      {rest.length > 0 && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          title="Tüm muhataplar"
          className={`inline-flex shrink-0 items-center gap-0.5 rounded-md border px-1.5 py-0.5 font-SemiBold transition-colors ${
            open
              ? "border-teal-300 bg-teal-50 text-teal-700"
              : "border-gray-200 bg-white text-gray-500 hover:border-teal-200 hover:text-teal-700"
          }`}
        >
          +{rest.length}
          <FaChevronDown className={`h-2 w-2 transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      )}
      {open && (
        <div className="absolute left-0 top-full z-30 mt-1 w-max min-w-[220px] max-w-[320px] rounded-xl border border-gray-200 bg-white p-1.5 shadow-lg">
          <p className="px-2 pb-1 pt-0.5 text-[10px] font-SemiBold tracking-wide text-gray-400">
            MUHATAPLAR ({list.length})
          </p>
          <ul className="max-h-56 overflow-y-auto">
            {list.map((c, i) => (
              <li key={`${c.name}-${i}`} className="rounded-lg px-2 py-1.5 hover:bg-gray-50">
                <ContactLine contact={c} />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default memo(FirmContactsMenu);
